import Container from '@mui/material/Container';

import OrderStatusFF from '@/assets/sidebar/orderStatusFF';
import SectionTitle from '@/components/SectionTitle/SectionTitle';
import usePageTitle from '@/hooks/usePageTitle';
import OrderStatusTable from '@/sections/Fulfill/OrderStatus/Table/orderStatusTable';

const OrderStatusPage = () => {
  usePageTitle('Fulfill99 - Estatus de órdenes');

  return (
    <Container maxWidth="xxl">
      <SectionTitle title={'Estatus de órdenes'} mt={5}>
        <OrderStatusFF fontSize="large" />
      </SectionTitle>
      <OrderStatusTable />
    </Container>
  );
};

export default OrderStatusPage;
